import type { IntlShape } from 'react-intl';

export function getCopyrightText({ intl }: { intl: IntlShape }) {
  return intl.formatMessage({ defaultMessage: '© 2010-{year} AllTrails, LLC' }, { year: new Date().getFullYear() });
}
